import * as XLSX from 'xlsx';

export const generateAnalyticsSheet = (analytics, startDateStr, endDateStr, textMessages, voiceMails, clid) => {
  const analyticsData = [
    ['Metric', 'Value'],
    ['Total Conversations', analytics.total_conversations],
    ['Conversations with Reply', analytics.conversations_with_reply],
    ['Reply Rate', `${(analytics.conversations_with_reply_percentage * 100).toFixed(1)}%`],
    ['Voice Mails Count', analytics.voice_mails_count],
    ['Voice Mails with Reply', analytics.voice_mails_with_reply_count],
    ['Voice Mail Reply Rate', `${(analytics.voice_mails_with_reply_percentage * 100).toFixed(1)}%`],
    ['', ''],
    ['Export Information', ''],
    ['Start Date', startDateStr],
    ['End Date', endDateStr],
    ['Export Date', new Date().toISOString().split('T')[0]],
    ['Total Text Messages', textMessages.length],
    ['Total Voice Mails', voiceMails.length]
  ];

  const analyticsSheet = XLSX.utils.aoa_to_sheet(analyticsData);

  // Style the analytics sheet
  analyticsSheet['!cols'] = [
    { width: 25 },
    { width: 15 }
  ];

  return analyticsSheet;
};

export const generateTextMessagesSheet = (textMessages) => {
  const textData = [
    ['Conversation ID', 'Timestamp', 'Content']
  ];

  textMessages.forEach(message => {
    textData.push([
      message.conversation_id || '',
      message.timestamp || '',
      message.message_content || ''
    ]);
  });

  const textSheet = XLSX.utils.aoa_to_sheet(textData);

  // Style the text messages sheet
  textSheet['!cols'] = [
    { width: 20 },
    { width: 20 },
    { width: 60 }
  ];
  return textSheet;
}

// 3. Voice Mails Sheet
export const generateVoiceMailsSheet = (voiceMails) => {
  const voiceData = [
    ['Conversation ID', 'Timestamp', 'Content', 'Duration']
  ];

  voiceMails.forEach(message => {
    voiceData.push([
      message.conversation_id || '',
      message.timestamp || '',
      message.message_content || '',
      message.duration || ''
    ]);
  });

  const voiceSheet = XLSX.utils.aoa_to_sheet(voiceData);

  // Style the voice mails sheet
  voiceSheet['!cols'] = [
    { width: 20 },
    { width: 20 },
    { width: 60 },
    { width: 10 }
  ];

  return voiceSheet;
}

export function generateExcelFile_default(textMessages, voiceMails, analytics, startDateStr, endDateStr, clid) {
  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // 1. Analytics Sheet
  if (analytics) {
    const analyticsSheet = generateAnalyticsSheet(analytics, startDateStr, endDateStr, textMessages, voiceMails, clid);
    XLSX.utils.book_append_sheet(workbook, analyticsSheet, 'Analytics');
  }

  // 2. Text Messages Sheet
  if (textMessages.length > 0) {
    const textSheet = generateTextMessagesSheet(textMessages);
    XLSX.utils.book_append_sheet(workbook, textSheet, 'Text Messages');
  }

  // 3. Voice Mails Sheet
  if (voiceMails.length > 0) {
    const voiceSheet = generateVoiceMailsSheet(voiceMails);
    XLSX.utils.book_append_sheet(workbook, voiceSheet, 'Voice Mails');
  }

  // Generate Excel file and download
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `conversations_export_${startDateStr}_to_${endDateStr}.xlsx`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
